<template>
  <div class="content1">
    <div class="other_product">
      <!-- 轮播图开始 -->
      <div class="swiper-slide" v-for="(item, index) in RecommendExhibits" :key="index">
        <div class="card" @click="routerDetail(item)">
          <div class="parameter">
            <div class="title">{{ lang == 'zh' ? item.exhibitsName: item.column25 }}</div>
            <div class="english">{{ item.seriesName }}</div>
            <div class="txt">{{ item.column17 }}</div>
          </div>
          <div class="backImg">
            <img :src="item.exhibitsCoverImg" alt="" v-if="item.exhibitsCoverImg.substr(0,4) == 'http'" />
            <img :src="baseUrl + item.exhibitsCoverImg" alt="" v-else />
            <!-- <img src="../../../static/占位-展品-列表.png" alt="" v-else /> -->
          </div>
          <div class="companyName">
            <span class="leftTitle">{{lang == 'zh' ? item.hzExhibitor.companyNameC : item.hzExhibitor.companyNameE }}</span>
          </div>
          <div class="boxBottom">
            <span class="bottomTxt" @click="routerDetail(item)">{{ $t('common.more') }}</span>
            <span class="bottomImg">
              <img
                :src="item.collectStatus ? require('../../../static/collent_yello.png') : require('../../../static/collen1t.png')"
                alt=""
                @click.stop="toggle(item)"
              />
            </span>
          </div>
        </div>
      </div>
      <!-- <div class="swiper-button-prev" slot="button-prev"></div>
      <div class="swiper-button-next" slot="button-next"></div> -->
    </div>
    <GoLogin :dialogVisible.sync="dialogVisible" @func="getMsgFormSon" @funcancel="getCancel" />
  </div>
</template>

<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper';
import 'swiper/dist/css/swiper.css';
import { getOtherEx, collecExhibit } from '../../../../api/exhibitProduct.js';
import * as tools from '../../../../utils/roulink';
import { forMat } from '../../../../utils/common.js';
import GoLogin from '../../../common/mobile/goLogin.vue'; //登录提示框

export default {
  name: 'exhibitorsLive',
  data() {
    return {
      baseUrl: forMat(),
      dialogVisible: false,
      RecommendExhibits: [],
    };
  },
  props: ['zsId', 'zpId', 'lang'],
  components: {
    swiper,
    swiperSlide,
    GoLogin,
  },

  computed: {},

  methods: {
    // 切换产品的收藏
    async toggle(item) {
      // item.collectStatus = !item.collectStatus;
      const willStatus = !item.collectStatus;
      // 添加或者取消收藏
      const params = {
        objId: item.id,
        flag: willStatus,
        type: 2,
      };
      // const toggleStatus = item.collectStatus === true ? true : false;
      try {
        const { data } = await collecExhibit(params);
        if (data.code === 200) {
          if (!item.collectStatus) {
            item.collectStatus = !item.collectStatus;
            this.$message({
              showClose: true,
              message: this.$t('common.successCollect'),
              type: 'success',
            });
          } else {
            item.collectStatus = !item.collectStatus;
            this.$message({
              showClose: true,
              message: this.$t('common.cancelCollect'),
              type: 'error',
            });
          }
          this.getOtherExInfo();
        } else {
          // this.$message({
          //   showClose: true,
          //   message: data.msg,
          //   type: 'warning',
          // });
          // tools.login(3);
        }
      } catch (err) {
        if (err == 'noLogin') {
          this.dialogVisible = true;
        }
        console.log(err);
      }
    },
    getMsgFormSon(data) {
      this.dialogVisible = data;
      tools.login(3);
    },
    getCancel(data) {
      this.dialogVisible = data;
    },
    // 获取其他展品信息
    async getOtherExInfo() {
      const params = { exhibitsId: this.zpId, exhibitorId: this.zsId };
      try {
        const { data } = await getOtherEx(params);
        this.RecommendExhibits = data.data;
        // data.data.forEach((it)=> {
        //   this.RecommendExhibits.push(it)
        //   this.RecommendExhibits.push(it)
        // })测试轮播图效果
      } catch (err) {
        console.log(err);
      }
    },
    routerDetail(val) {
      this.$router.push({
        name: 'exhibItem_detail',
        query: {
          id: val.id,
        },
      });
      setTimeout(() => {
        this.getOtherExInfo();
      }, 1000);
    },
  },
  created() {
    setTimeout(() => {
      this.getOtherExInfo();
    }, 1000);
  },
};
</script>
<style lang="scss" scoped>
.content1 {
  width: 100%;
  margin: 0 auto;
  //margin-top: 114px;
  margin-bottom: 10.67vw;
  h3 {
    font-size: 4.8vw;
    font-family: Microsoft YaHei;
    font-weight: 400;
    margin-bottom: 6.6vw;
    color: #006fb8;
    width: 20.27vw;
    border-left: 0.4vw solid #006fb8;
    border-right: 0.4vw solid #006fb8;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 4vw;
  }
  .other_product {
    display: flex;
    position: relative;

    .swiper-container {
      width: 100%;
    }
    .swiper-slide {
      width: 39.3vw !important;
      height: 66.4vw;
      border: 1px solid #e0e0e0;
      margin-left: 0;
      background: #ffffff;
      margin: 15px 11px;
      &:hover {
        box-shadow: 0px 0px 15px 0px #b8bfc5;
      }

      //   margin-left: 28px;
      //   margin-bottom: 28px;
      .parameter {
        height: 20vw;
        padding-top: 4.1vw;
        box-sizing: border-box;
        .title {
          font-size: 4.3vw;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #333333;
          //margin-top: 30px;
          margin-left: 3.2vw;
          max-width: 30.9vw;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 1;
          word-break: break-all;
          line-height: 4.3vw;
        }
        .english {
          margin-top: 1.8vw;
          margin-left: 3.2vw;
          font-size: 2.6vw;
          font-family: Microsoft YaHei;
          font-weight: bold;
          color: #333333;
          max-width: 30.9vw;
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
        }
        .txt {
          font-size: 2.6vw;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #999999;
          margin-top: 1.3vw;
          margin-left: 3.2vw;
          max-width: 30.9vw;
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
        }
      }

      .backImg {
        width: 30.9vw;
        height: 22.9vw;
        margin: 0px auto 5px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .companyName {
        margin: 19px 3.2vw 20px 3.2vw;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        .leftTitle {
          font-size: 2.6vw;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #999999;
          text-overflow: ellipsis;
          white-space: nowrap;
          max-width: 100%;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
      .boxBottom {
        height: 10vw;
        width: 100%;
        border-radius: 1px;
        border-top: 1px solid #e0e0e0;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-left: 4vw;
        padding-right: 4vw;
        box-sizing: border-box;
        .bottomTxt {
          cursor: pointer;
          font-size: 3.2vw;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #006fb8;
        }
        .bottomImg {
          width: 4vw;
          height: 3.7vw;
          line-height: 4vw;
          img {
            width: 100%;
            height: 100%;
          }
        }
      }
    }

    .swiper-button-prev {
      width: 48px;
      height: 48px;
      margin-left: -8px;
      background-image: url('../../../static/left.png');
    }
    .swiper-button-next {
      background-image: url('../../../static/right.png');
    }
  }
}

.swiper-slide {
  // height: 66.4vw !important;
  width: 39.3vw !important;
}
</style>
